// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2024/2/2
// +-------------------------------------------------------------
// |Time: 14:29
// +-------------------------------------------------------------
import {createRouter, createWebHashHistory} from 'vue-router'
import routes from './module/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {useUserStore} from "@/store/module/user";

NProgress.configure({showSpinner: false})

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
//渲染一个路由的过程中，尝试解析一个异步组件时发生的错误
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
/**
 * Router 前置拦截
 *
 * 1.验证 token 存在, 并且有效, 否则 -> login.vue
 * 2.验证 permission 存在, 否则 -> 403.vue
 * 3.验证 router 是否存在, 否则 -> 404.vue
 *
 * @param to 目标
 * @param from 来至
 */
let userStore = null;
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 管理系统`;
    NProgress.start();
    if (userStore === null) {
        userStore = useUserStore()
    }
    if (!userStore.token && to.path !== '/login') {
        next('/login');
    } else if(to.matched.length == 0) {
        // next({path: '/error/404'})
        next();
    } else {
        next();
    }
})

router.afterEach(() => {
    NProgress.done();
})

export default router
